// For FAQ accordian

var accItem = document.getElementsByClassName('accordion-item');
var accHD = document.getElementsByClassName('accordion-item-heading');
for (i = 0; i < accHD.length; i++) {
    accHD[i].addEventListener('click', toggleItem, false);
}
function toggleItem() {
    var itemClass = this.parentNode.className;
    for (i = 0; i < accItem.length; i++) {
        accItem[i].className = 'accordion-item close';
        accHD[i].nextElementSibling.style.height = 0;
    }
    if (itemClass == 'accordion-item close') {
        this.parentNode.className = 'accordion-item open';
        this.nextElementSibling.style.height = this.nextElementSibling.scrollHeight + "px";
    }
}
$(document).ready(function () {
    $(document).on('click', '.smoothScroll', function (event) {
        if (this.hash !== "") {
            event.preventDefault();
            var hash = this.hash;
            window.setTimeout(function(){
                $('html, body').animate({
                    scrollTop: $(hash).offset().top
                }, 800, function () {
                    window.location.hash = hash;
                });
            },400);
        }
    })
});
